/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Lightbulb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Lightbulb"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#FFC220"
        d="M7.266 7.254a6.625 6.625 0 0 1 9.33 0 6.53 6.53 0 0 1 0 9.275l-.86 1.01a5 5 0 0 1-7.61 0l-.86-1.01a6.53 6.53 0 0 1 0-9.275M4.5 8.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m5-5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m7.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m5 5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M4.5 14.917a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m17.5 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        className="Fill-Main"
      />
      <path
        fill="#666"
        d="M9.5 18.667h5v1.666c0 .92-.746 1.667-1.667 1.667h-1.666c-.92 0-1.667-.746-1.667-1.667z"
        className="Fill-Secondary"
      />
      <path
        fill="#fff"
        d="M16.375 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
        className="Fill-Accent"
      />
    </g>
  </svg>
);

export const LightbulbIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'lightbulb-icon'}
      icon={Lightbulb}
      {...props}
      size={size}
    />
  );
};
